import { Pages } from 'interfaces/main';
import config from 'config/common';
import { FeatureFlags } from 'config/featureFlags.constants';
import {
    CustomNavOpenWith,
    CustomNavigationButtonConfig,
    useCustomNavigationButton,
} from './useCustomNavigationButton';

type OnClick = (...args: any[]) => void;

interface EducationMenuProps {
    link: string | undefined;
    outsideLink: boolean;
    onClick: OnClick;
}

export interface TradersEducationMenuResult {
    menuProps: EducationMenuProps;
    isBpCustomNavEnabled: boolean;
    isEducationVisible: boolean;
    isEducationOnTop: boolean;
}

function resolveMenuProps(
    customNavButton: CustomNavigationButtonConfig,
    isBpCustomNavEnabled: boolean,
    onMenuItemClick: OnClick,
    openDialog: OnClick
): EducationMenuProps {
    if (isBpCustomNavEnabled) {
        switch (customNavButton.openWith) {
            case CustomNavOpenWith.NEWTAB:
                return { link: customNavButton.targetUrl, outsideLink: true, onClick: onMenuItemClick };
            case CustomNavOpenWith.IFRAME:
                return { link: `/${Pages.CUSTOM_NAVIGATION}`, outsideLink: false, onClick: onMenuItemClick };
            default:
                return { link: undefined, outsideLink: false, onClick: openDialog };
        }
    }

    return config.tradersEducation?.openInNewTab
        ? { link: config.tradersEducation?.url, outsideLink: true, onClick: onMenuItemClick }
        : { link: undefined, outsideLink: false, onClick: openDialog };
}

export const useTradersEducationMenuItem = (onMenuItemClick: OnClick): TradersEducationMenuResult => {
    const customNavButton = useCustomNavigationButton();
    const isEducationOnTop = !!config.featuresFlags[FeatureFlags.EDUCATION_ON_TOP];
    const isBpCustomNavEnabled = !customNavButton.isLegacyMode && customNavButton.isEnabled;
    const isLegacyEducationAvailable =
        customNavButton.isLegacyMode &&
        !!config.featuresFlags[FeatureFlags.TRADERS_EDUCATION] &&
        !!config.tradersEducation?.url;
    const isEducationVisible = isBpCustomNavEnabled || isLegacyEducationAvailable;
    const openDialog: OnClick = () => onMenuItemClick({ tradersEducationClick: true });

    return {
        menuProps: resolveMenuProps(customNavButton, isBpCustomNavEnabled, onMenuItemClick, openDialog),
        isBpCustomNavEnabled,
        isEducationVisible,
        isEducationOnTop,
    };
};
